import createIcon from '../../createIcon';

/**
 * @component @name Tenk
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTAgMTAuNUgxMS41VjEzLjVIMTBWMTAuNVpNMTkgM0g1QzMuOSAzIDMgMy45IDMgNVYxOUMzIDIwLjEgMy45IDIxIDUgMjFIMTlDMjAuMSAyMSAyMSAyMC4xIDIxIDE5VjVDMjEgMy45IDIwLjEgMyAxOSAzWk03LjUgMTVINlYxMC41SDQuNVY5SDcuNVYxNVpNMTMgMTRDMTMgMTQuNTUgMTIuNTUgMTUgMTIgMTVIOS41QzguOTUgMTUgOC41IDE0LjU1IDguNSAxNFYxMEM4LjUgOS40NSA4Ljk1IDkgOS41IDlIMTJDMTIuNTUgOSAxMyA5LjQ1IDEzIDEwVjE0Wk0xOS41IDE1SDE3Ljc1TDE2IDEyLjc1VjE1SDE0LjVWOUgxNlYxMS4yNUwxNy43NSA5SDE5LjVMMTcuMjUgMTJMMTkuNSAxNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Tenk = createIcon('Tenk', [
  [
    'path',
    {
      d: 'M10 10.5H11.5V13.5H10V10.5ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM7.5 15H6V10.5H4.5V9H7.5V15ZM13 14C13 14.55 12.55 15 12 15H9.5C8.95 15 8.5 14.55 8.5 14V10C8.5 9.45 8.95 9 9.5 9H12C12.55 9 13 9.45 13 10V14ZM19.5 15H17.75L16 12.75V15H14.5V9H16V11.25L17.75 9H19.5L17.25 12L19.5 15Z',
      key: 'hu9t34',
    },
  ],
]);

export default Tenk;
